// import { ThemeEvents } from "@theme/events";
// import Toastify from '@theme/toastify';

// class VariantUploads extends HTMLElement {
//   #abortController = new AbortController();

//   constructor() {
//     super();
//     const { signal } = this.#abortController;
//     const target = this.closest(".shopify-section, dialog");
//     target?.addEventListener(
//       ThemeEvents.variantUpdate,
//       this.onVariantUpdate.bind(this),
//       { signal }
//     );
//   }

//   disconnectedCallback() {
//     this.#abortController.abort();
//   }

//   onVariantUpdate(event) {
//     if (!event.detail.resource) return;

//     const variant = event.detail.resource;
//     if (!variant?.id) return;

//     const container = this.closest(".shopify-section, dialog, product-card");
//     const variantSelectedInput = container?.querySelector(
//       `input[data-option-variant-id="${variant.id}"]`
//     );

//     if (!variantSelectedInput) return;

//     const optionsUpload = Number(
//       variantSelectedInput.getAttribute("data-option-uploads")
//     );

//     this.hideShowUploads(optionsUpload);
//   }

//   hideShowUploads(optionsUpload) {
//     if (!optionsUpload) return;

//     const uploadElements = this.querySelectorAll("variant-upload");

//     uploadElements.forEach((element, i) => {
//       if (i + 1 > optionsUpload) {
//         element.classList.add("vp-uploads-card--hidden");
//         element.querySelectorAll("input, textarea").forEach((input) => {
//           input.setAttribute("disabled", "");
//         });
//       } else {
//         element.classList.remove("vp-uploads-card--hidden");
//         element.querySelectorAll("input, textarea").forEach((input) => {
//           input.removeAttribute("disabled");
//         });
//       }
//       this.#toggleFreeBadge(element, optionsUpload, i);
//     });
//   }

//   #toggleFreeBadge(element, optionsUpload, index) {
//     const badge = element.querySelector(".variant-option__free-badge");
//     if (!badge) return;

//     // Standardized rule:
//     // - For 3 uploads: show badge on index == 2 (3rd card)
//     // - For 6 uploads: show badge on index >= 3 (4th to 6th cards)
//     switch (optionsUpload) {
//       case 3:
//         if (index === 2) badge.classList.add("is-visible");
//         else badge.classList.remove("is-visible");
//         break;
//       case 6:
//         if (index >= 4) badge.classList.add("is-visible");
//         else badge.classList.remove("is-visible");
//         break;
//       default:
//         badge.classList.remove("is-visible");
//         break;
//     }
//   }
// }

// if (!customElements.get("variant-uploads")) {
//   customElements.define("variant-uploads", VariantUploads);
// }

// class VariantUpload extends HTMLElement {
//   /** @type {HTMLImageElement | null} */
//   imagePlaceholder = null;
//   /** @type {HTMLLabelElement | null} */
//   uploadLabel = null;
//   constructor() {
//     super();
//     this.addEventListener("change", this.onImageChange.bind(this));
//     const img = this.querySelector(".vp-uploads-card__icon img");
//     this.imagePlaceholder = img instanceof HTMLImageElement ? img : null;
//     const label = this.querySelector(".vp-uploads-card__button");
//     this.uploadLabel = label instanceof HTMLLabelElement ? label : null;
//   }

//   /**
//    * @param {Event & { target: EventTarget | HTMLInputElement }} event
//    */
//   async onImageChange(event) {
//     const img = this.imagePlaceholder;
//     if (!(img instanceof HTMLImageElement)) return;

//     const target = event.target;
//     if (!(target instanceof HTMLInputElement)) return;

//     const file = target.files?.[0];
//     if (!file) {
//       const placeholder =
//         img.getAttribute("data-upload-placeholder-url") ||
//         img.dataset.uploadPlaceholderUrl;
//       if (placeholder) img.src = placeholder;
//       // Update label text when image is removed
//       if (this.uploadLabel) {
//         this.uploadLabel.textContent = "Upload";
//       }
//       return;
//     }

//     const result =  await this.#checkImageSize(file);

//     if(!result.valid) {
//       event.target.value = '';
      
//       // Restore placeholder image
//       const placeholder = img.getAttribute("data-upload-placeholder-url") || img.dataset.uploadPlaceholderUrl;
//       if (placeholder) img.src = placeholder;
//       // Update label text when image validation fails
//       if (this.uploadLabel) {
//         this.uploadLabel.textContent = "Upload";
//       }

//       Toastify({
//         text: result.errors[0],
//         duration: 3000,
//         newWindow: true,
//         close: false,
//         avatar: Theme.toast.error_icon,  
//         gravity: "bottom", // `top` or `bottom`
//         position: "right", // `left`, `center` or `right`
//         stopOnFocus: true, // Prevents dismissing of toast on hover
//         style: {
//           display: "flex",
//           alignItems: "center",
//           gap: "8px",
//           background: "#B91C1C",
//           color: "#ffffff",
//           fontSize: window.innerWidth < 768 ? "15px" : "14px",
//           borderRadius: "5px",
//           boxShadow: "none",
//           padding: '12px 16px 12px 8px',
//           lineHeight: "1.2"
//         },
//         onClick: function(){} // Callback after click
//       }).showToast()

//       return;
//     }

//     const reader = new FileReader();
//     reader.onload = (e) => {
//       const result =
//         e.target && typeof e.target.result === "string" ? e.target.result : "";
//       if (result) {
//         img.src = result;
//         // Update label text when image is added
//         if (this.uploadLabel) {
//           this.uploadLabel.textContent = "Replace";
//         }
//       }
//     };
//     reader.readAsDataURL(file);
//   }

//   /**
//    * Validates uploaded image file size and dimensions
//    * Max file size: 10MB
//    * Max resolution: 10000px (width or height)
//    * @param {File} file - The uploaded image file
//    * @returns {Promise<{valid: boolean, width?: number, height?: number, fileSize: number, errors: string[]}>}
//    */
//   async #checkImageSize(file) {
//     const MAX_FILE_SIZE = 15 * 1024 * 1024; // 10MB in bytes
//     const MAX_DIMENSION = 10000; // 10000px
//     const errors = [];
    
//     // Check if file exists
//     if (!file) {
//       errors.push("No file selected");
//       return { valid: false, fileSize: 0, errors };
//     }

//     // Check if it's an image
//     if (!file.type.startsWith('image/')) {
//       errors.push("File must be an image");
//       return { valid: false, fileSize: file.size, errors };
//     }

//     // Check file size (10MB max)
//     if (file.size > MAX_FILE_SIZE) {
//       const fileSizeMB = (file.size / 1024 / 1024).toFixed(2);
//       errors.push(`File size (${fileSizeMB}MB) exceeds maximum of 5MB`);
//     }

//     // Load image to check dimensions
//     return new Promise((resolve) => {
//       const img = new Image();
//       const url = URL.createObjectURL(file);

//       img.onload = () => {
//         const width = img.naturalWidth;
//         const height = img.naturalHeight;

//         // Check if dimensions exceed 10000px
//         if (width > MAX_DIMENSION || height > MAX_DIMENSION) {
//           errors.push(`Image resolution (${width}x${height}px) exceeds maximum of ${MAX_DIMENSION}px`);
//         }

//         // Clean up object URL
//         URL.revokeObjectURL(url);

//         resolve({
//           valid: errors.length === 0,
//           width,
//           height,
//           fileSize: file.size,
//           errors,
//         });
//       };

//       img.onerror = () => {
//         URL.revokeObjectURL(url);
//         errors.push("Failed to load image");
//         resolve({ valid: false, fileSize: file.size, errors });
//       };

//       img.src = url;
//     });
//   }
// }

// if (!customElements.get("variant-upload")) {
//   customElements.define("variant-upload", VariantUpload);
// }















import { ThemeEvents } from "@theme/events";
import Toastify from '@theme/toastify';

class VariantUploads extends HTMLElement {
  #abortController = new AbortController();

  constructor() {
    super();
    const { signal } = this.#abortController;
    const target = this.closest(".shopify-section, dialog");
    target?.addEventListener(
      ThemeEvents.variantUpdate,
      this.onVariantUpdate.bind(this),
      { signal }
    );
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  onVariantUpdate(event) {
    if (!event.detail.resource) return;

    const variant = event.detail.resource;
    if (!variant?.id) return;

    const container = this.closest(".shopify-section, dialog, product-card");
    const variantSelectedInput = container?.querySelector(
      `input[data-option-variant-id="${variant.id}"]`
    );

    if (!variantSelectedInput) return;

    const optionsUpload = Number(
      variantSelectedInput.getAttribute("data-option-uploads")
    );

    this.hideShowUploads(optionsUpload);
  }

  hideShowUploads(optionsUpload) {
    if (!optionsUpload) return;

    const uploadElements = this.querySelectorAll("variant-upload");

    uploadElements.forEach((element, i) => {
      if (i + 1 > optionsUpload) {
        element.classList.add("vp-uploads-card--hidden");
        element.querySelectorAll("input, textarea").forEach((input) => {
          input.setAttribute("disabled", "");
        });
      } else {
        element.classList.remove("vp-uploads-card--hidden");
        element.querySelectorAll("input, textarea").forEach((input) => {
          input.removeAttribute("disabled");
        });
      }
      this.#toggleFreeBadge(element, optionsUpload, i);
    });
  }

  #toggleFreeBadge(element, optionsUpload, index) {
    const badge = element.querySelector(".variant-option__free-badge");
    if (!badge) return;

    // Standardized rule:
    // - For 3 uploads: show badge on index == 2 (3rd card)
    // - For 6 uploads: show badge on index >= 3 (4th to 6th cards)
    switch (optionsUpload) {
      case 3:
        if (index === 2) badge.classList.add("is-visible");
        else badge.classList.remove("is-visible");
        break;
      case 6:
        if (index >= 4) badge.classList.add("is-visible");
        else badge.classList.remove("is-visible");
        break;
      default:
        badge.classList.remove("is-visible");
        break;
    }
  }
}

if (!customElements.get("variant-uploads")) {
  customElements.define("variant-uploads", VariantUploads);
}

class VariantUpload extends HTMLElement {
  /** @type {HTMLImageElement | null} */
  imagePlaceholder = null;
  /** @type {HTMLLabelElement | null} */
  uploadLabel = null;
  /** @type {string | null} */
  #previewObjectUrl = null;
  constructor() {
    super();
    this.addEventListener("change", this.onImageChange.bind(this));
    const img = this.querySelector(".vp-uploads-card__icon img");
    this.imagePlaceholder = img instanceof HTMLImageElement ? img : null;
    const label = this.querySelector(".vp-uploads-card__button");
    this.uploadLabel = label instanceof HTMLLabelElement ? label : null;
  }

  /**
   * @param {Event & { target: EventTarget | HTMLInputElement }} event
   */
  async onImageChange(event) {
    const img = this.imagePlaceholder;
    if (!(img instanceof HTMLImageElement)) return;

    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;

    const file = target.files?.[0];
    if (!file) {
      this.#resetPreviewImage();
      const placeholder =
        img.getAttribute("data-upload-placeholder-url") ||
        img.dataset.uploadPlaceholderUrl;
      if (placeholder) img.src = placeholder;
      if (this.uploadLabel) {
        this.uploadLabel.textContent = "Upload";
      }
      return;
    }

    // Quick validation before any heavy processing
    const quickValidation = this.#quickValidate(file);
    if (!quickValidation.valid) {
      this.#showError(quickValidation.errors[0]);
      target.value = '';
      return;
    }

    // Show immediate preview
    const previewUrl = this.#createObjectUrl(file);
    if (previewUrl) {
      this.#updatePreviewImage(previewUrl);
    }

    // Check if optimization is disabled (for faster uploads)
    const skipOptimization = this.hasAttribute('data-skip-optimization');

    if (skipOptimization) {
      // Skip all optimization - just use file as-is (like old fast version)
      return;
    }

    // Run optimization (which includes dimension check)
    const optimization = await this.#optimizeImage(file);
    const fileForUpload = optimization?.file ?? file;
    const dimensions = optimization?.dimensions;

    // Validate dimensions from optimization (no extra image load needed)
    if (dimensions) {
      const MAX_DIMENSION = 10000;
      if (dimensions.width > MAX_DIMENSION || dimensions.height > MAX_DIMENSION) {
        this.#handleValidationFailure(target, img, previewUrl);
        this.#showError(`Image resolution (${dimensions.width}x${dimensions.height}px) exceeds maximum of ${MAX_DIMENSION}px`);
        return;
      }
    }

    if (optimization?.changed) {
      this.#replaceInputFile(target, fileForUpload);
      // Update preview with optimized file if different
      if (previewUrl) URL.revokeObjectURL(previewUrl);
      const optimizedPreviewUrl = this.#createObjectUrl(fileForUpload);
      if (optimizedPreviewUrl) {
        this.#updatePreviewImage(optimizedPreviewUrl);
      }
    }
  }

  #quickValidate(file) {
    const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB like old fast version
    const errors = [];

    if (!file.type.startsWith('image/')) {
      errors.push("File must be an image");
    }

    if (file.size > MAX_FILE_SIZE) {
      const fileSizeMB = (file.size / 1024 / 1024).toFixed(2);
      errors.push(`File size (${fileSizeMB}MB) exceeds maximum of 10MB`);
    }

    return { valid: errors.length === 0, errors };
  }

  #handleValidationFailure(target, img, previewUrl) {
    target.value = '';
    if (previewUrl) URL.revokeObjectURL(previewUrl);
    this.#resetPreviewImage();
    const placeholder = img.getAttribute("data-upload-placeholder-url") || img.dataset.uploadPlaceholderUrl;
    if (placeholder) img.src = placeholder;
    if (this.uploadLabel) {
      this.uploadLabel.textContent = "Upload";
    }
  }

  #showError(message) {
    const showToast = /** @type {(options: any) => { showToast(): void }} */ (Toastify);
    showToast({
      text: message,
      duration: 3000,
      newWindow: true,
      close: false,
      avatar: Theme.toast.error_icon,
      gravity: "bottom",
      position: "right",
      stopOnFocus: true,
      style: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        background: "#B91C1C",
        color: "#ffffff",
        fontSize: window.innerWidth < 768 ? "15px" : "14px",
        borderRadius: "5px",
        boxShadow: "none",
        padding: '12px 16px 12px 8px',
        lineHeight: "1.2"
      },
      onClick: function(){}
    }).showToast();
  }

  #createObjectUrl(file) {
    if (typeof URL === "undefined" || typeof URL.createObjectURL !== "function") {
      return null;
    }

    try {
      return URL.createObjectURL(file);
    } catch (error) {
      console.error("Failed to create object URL", error);
      return null;
    }
  }

  #updatePreviewImage(previewUrl) {
    const img = this.imagePlaceholder;
    if (!(img instanceof HTMLImageElement)) return;

    this.#resetPreviewImage();
    this.#previewObjectUrl = previewUrl;

    const handleLoad = () => {
      img.removeEventListener("load", handleLoad);
      if (this.#previewObjectUrl === previewUrl) {
        // Keep URL alive until next selection; do nothing here.
      } else {
        URL.revokeObjectURL(previewUrl);
      }
    };

    img.addEventListener("load", handleLoad);
    img.src = previewUrl;
    if (this.uploadLabel) {
      this.uploadLabel.textContent = "Replace";
    }
  }

  #resetPreviewImage() {
    if (this.#previewObjectUrl) {
      URL.revokeObjectURL(this.#previewObjectUrl);
      this.#previewObjectUrl = null;
    }
  }

  #replaceInputFile(input, file) {
    if (typeof DataTransfer === "undefined") return;

    const transfer = new DataTransfer();
    transfer.items.add(file);
    input.files = transfer.files;
  }

  async #optimizeImage(file) {
    const SUPPORTED = /image\/(jpeg|jpg|png|webp)/i;
    const SKIP_THRESHOLD = 5 * 1024 * 1024; // 5MB - skip optimization for files under this
    const TARGET_BYTES = 1 * 1024 * 1024; // 1MB target for compression
    const MAX_EDGE = 2800;

    if (!SUPPORTED.test(file.type)) return null;

    // Skip optimization entirely for files under 5MB - just get dimensions
    if (file.size <= SKIP_THRESHOLD) {
      const bitmap = await this.#createBitmap(file);
      if (!bitmap) return null;
      const { width, height } = bitmap;
      bitmap.dispose();
      return { dimensions: { width, height } };
    }

    const bitmap = await this.#createBitmap(file);
    if (!bitmap) return null;

    const { width: sourceWidth, height: sourceHeight, source } = bitmap;
    const maxEdge = Math.max(sourceWidth, sourceHeight);

    // Skip resize if already small enough
    if (maxEdge <= MAX_EDGE && file.size <= SKIP_THRESHOLD) {
      bitmap.dispose();
      return { dimensions: { width: sourceWidth, height: sourceHeight } };
    }

    const scale = Math.min(1, MAX_EDGE / maxEdge);
    const outputWidth = Math.max(1, Math.round(sourceWidth * scale));
    const outputHeight = Math.max(1, Math.round(sourceHeight * scale));

    const canvas = this.#createCanvas(outputWidth, outputHeight);
    const context = /** @type {CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D | null} */ (
      canvas.getContext("2d", { alpha: file.type === "image/png" })
    );

    if (!context) {
      bitmap.dispose();
      return null;
    }

    /** @type {CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D} */ (context).drawImage(
      source,
      0,
      0,
      outputWidth,
      outputHeight
    );
    bitmap.dispose();

    const mimeType = file.type === "image/png" ? "image/png" : "image/jpeg";
    let quality = 0.85;
    let blob = await this.#canvasToBlob(canvas, mimeType, quality);

    // Reduce quality iterations - only do 2 steps max instead of many
    if (blob && blob.size > TARGET_BYTES && mimeType !== "image/png") {
      quality = 0.6;
      blob = await this.#canvasToBlob(canvas, mimeType, quality);
    }

    if (!blob || blob.size >= file.size) {
      return { dimensions: { width: sourceWidth, height: sourceHeight } };
    }

    const optimizedFile = new File([blob], file.name, {
      type: blob.type,
      lastModified: Date.now(),
    });

    return {
      file: optimizedFile,
      changed: true,
      dimensions: { width: outputWidth, height: outputHeight },
    };
  }

  #createCanvas(width, height) {
    if (typeof OffscreenCanvas === "function") {
      return new OffscreenCanvas(width, height);
    }

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    return canvas;
  }

  async #canvasToBlob(canvas, mimeType, quality) {
    if ("convertToBlob" in canvas && typeof canvas.convertToBlob === "function") {
      return canvas.convertToBlob({ type: mimeType, quality });
    }

    return new Promise((resolve) => {
      canvas.toBlob(
        (blob) => resolve(blob ?? undefined),
        mimeType,
        quality
      );
    });
  }

  async #createBitmap(file) {
    if ("createImageBitmap" in window && typeof createImageBitmap === "function") {
      try {
        const bitmap = await createImageBitmap(file);
        return {
          source: bitmap,
          width: bitmap.width,
          height: bitmap.height,
          dispose: () => bitmap.close(),
        };
      } catch (error) {
        console.warn("createImageBitmap failed, falling back to <img>", error);
      }
    }

    return new Promise((resolve) => {
      const image = new Image();
      const objectUrl = this.#createObjectUrl(file);

      if (!objectUrl) {
        resolve(null);
        return;
      }

      image.onload = () => {
        URL.revokeObjectURL(objectUrl);
        resolve({
          source: image,
          width: image.naturalWidth,
          height: image.naturalHeight,
          dispose: () => {},
        });
      };

      image.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        resolve(null);
      };

      image.src = objectUrl;
    });
  }
}

if (!customElements.get("variant-upload")) {
  customElements.define("variant-upload", VariantUpload);
}
